export const newsKeys = {
  getAllNews: () => ['getAllNews'],
  getAllNewsWithParam: (params?: any) => ['getAllNews', params],
};
